import styled from 'styled-components'
import {FontWeights} from '../../styledComponents/Constants'

export const ContentBody = styled.div`
  max-width: 738px;
  margin: auto;
`

export const MeetingTitle = styled.span`
  font-weight: ${FontWeights.Bold};
`
